module.exports = __webpack_public_path__ + "static/media/mulher_r2_c6.2d9655a6.jpg";